import { Education } from '../types/Education';

import { baseApi } from './baseApi';

export const educationApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['Education'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getEducation: builder.query<Education[], number | undefined>({
        query: (id: number | undefined) => ({
          url: 'api/v6/careplan/education',
          params: id ? { procedure_id: id } : {},
        }),
        providesTags: (_result, _error, arg) => (
          arg ? [{ type: 'Education', id: arg }] : ['Education']
        ),
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetEducationQuery,
  useLazyGetEducationQuery,
} = educationApi;
